export const valueHandler = (value) => (isNaN(value) ? 0 : value);